// @ts-expect-error ts not available
import { ProgressBar, Step } from "react-step-progress-bar";
import styles from "./BundleBuilderBundle.module.css";
import { useEffect } from "react";
import "react-step-progress-bar/styles.css";
import type { ProductObj } from "../../Types";

const DispensaryBottleIcon = ({ size = 32, color = "#303030" }: { size?: number; color?: string }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 810 1012.5"
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: size, height: size }}
        >
            <path
                fill={color}
                fillRule="nonzero"
                d="M 548.007812 455.601562 C 546.742188 443.6875 543.292969 432.46875 537.839844 422.34375 C 527.277344 402.703125 511.039062 390.785156 504.097656 385.679688 C 498.816406 381.792969 494.367188 379.132812 490.785156 376.992188 C 484.632812 373.328125 480.921875 371.101562 476.820312 365.425781 C 473.195312 360.449219 470.578125 354.601562 469.09375 348.054688 L 469.09375 312.089844 L 480.921875 312.089844 C 484.851562 312.089844 488.035156 308.902344 488.035156 304.972656 L 488.035156 268.441406 C 488.035156 256.132812 478.039062 246.136719 465.730469 246.136719 L 344.261719 246.136719 C 331.953125 246.136719 321.957031 256.132812 321.957031 268.441406 L 321.957031 304.929688 C 321.957031 308.859375 325.140625 312.042969 329.070312 312.042969 L 340.898438 312.042969 L 340.898438 348.011719 C 339.414062 354.558594 336.796875 360.40625 333.171875 365.382812 C 329.027344 371.058594 325.359375 373.28125 319.207031 376.949219 C 315.625 379.089844 311.175781 381.75 305.894531 385.636719 C 298.996094 390.742188 282.761719 402.613281 272.152344 422.300781 C 266.699219 432.511719 263.25 443.6875 261.984375 455.601562 C 261.984375 455.863281 261.941406 456.125 261.941406 456.34375 L 261.941406 706.667969 C 261.941406 739.316406 288.476562 765.851562 321.125 765.851562 L 488.820312 765.851562 C 521.472656 765.851562 548.007812 739.316406 548.007812 706.667969 L 548.007812 456.386719 C 548.050781 456.125 548.007812 455.863281 548.007812 455.601562 Z M 336.183594 297.816406 L 336.183594 268.441406 C 336.183594 263.988281 339.808594 260.367188 344.261719 260.367188 L 465.6875 260.367188 C 470.140625 260.367188 473.761719 263.988281 473.761719 268.441406 L 473.761719 297.816406 Z M 454.820312 312.089844 L 454.820312 331.597656 L 355.128906 331.597656 L 355.128906 312.089844 Z M 533.824219 706.710938 C 533.824219 731.503906 513.65625 751.667969 488.867188 751.667969 L 321.125 751.667969 C 296.335938 751.667969 276.167969 731.503906 276.167969 706.710938 L 276.167969 456.78125 C 277.261719 446.875 280.140625 437.53125 284.679688 429.152344 C 293.757812 412.304688 308.164062 401.742188 314.316406 397.246094 C 319.074219 393.753906 323.046875 391.398438 326.539062 389.300781 C 333.128906 385.375 338.847656 381.925781 344.695312 373.894531 C 349.628906 367.128906 353.121094 359.226562 354.996094 350.453125 C 355.085938 349.976562 355.171875 349.449219 355.171875 348.925781 L 355.171875 345.914062 L 454.863281 345.914062 L 454.863281 348.925781 C 454.863281 349.449219 454.90625 349.929688 455.039062 350.453125 C 456.914062 359.226562 460.40625 367.128906 465.339844 373.894531 C 471.1875 381.96875 476.90625 385.375 483.496094 389.300781 C 486.988281 391.398438 490.960938 393.753906 495.71875 397.246094 C 501.871094 401.742188 516.277344 412.347656 525.355469 429.152344 C 529.894531 437.578125 532.777344 446.875 533.867188 456.78125 L 533.867188 706.710938 Z"
                stroke={color}
                strokeWidth={30}
            />
        </svg>
    );
};

const RenderCapacityIcon = ({ accomplished, bar_foreground_color, bar_background_color }: any) => {
    return (
        <span
            className={styles.rewardIcon}
            style={{
                backgroundColor: accomplished ? bar_foreground_color : bar_background_color,
                border: `1px solid ${accomplished ? bar_background_color : bar_foreground_color}`,
                // @ts-expect-error required
                "--icon-size": "27px",
            }}
        >
            <DispensaryBottleIcon size={32} color={accomplished ? bar_background_color : bar_foreground_color} />
        </span>
    );
};

const MergedCapacityProgressBar = ({
    selectedProducts,
    bar_foreground_color,
    bar_background_color,
    textColor,
}: {
    selectedProducts: ProductObj[];
    bar_foreground_color: string;
    bar_background_color: string;
    textColor: string;
}) => {
    useEffect(() => {
        const ele: any = document.getElementsByClassName("RSPBprogression");
        if (ele.length > 0) {
            ele[0].style.display = "block";
        }
    }, []);

    // Total capacity comes from the selected variants' capacityValue
    const totalCapacity = selectedProducts.reduce((sum, product) => {
        const productCapacity =
            product.selectedVariants?.reduce((variantSum, variant: any) => {
                const val = parseFloat(variant?.capacityValue);
                return variantSum + (isNaN(val) ? 0 : val);
            }, 0) ?? 0;

        return sum + productCapacity;
    }, 0);

    if (totalCapacity <= 0) return null;

    // Filled capacity comes from selected variants that do NOT have a capacityValue
    const filledCapacity = selectedProducts
        // .filter((product) => product.page === activeStep.toString())
        .reduce(
            (sum, product) =>
                sum +
                (product.selectedVariants?.filter((variant: any) => isNaN(parseFloat(variant?.capacityValue))).length ??
                    0),
            0,
        );

    const percent = totalCapacity > 0 ? Math.min(100, Math.round((filledCapacity / totalCapacity) * 100)) : 0;
    const accomplished = filledCapacity >= totalCapacity;

    return (
        <>
            <span
                className={styles.progressBarMainWrapper}
                style={{ position: "relative", transform: "translateX(0%)", minHeight: "35px", width: "100%" }}
            >
                <ProgressBar
                    className={styles.progressBarComponent}
                    percent={Math.floor(percent) || 2}
                    height={6}
                    filledBackground={bar_foreground_color}
                    unfilledBackground={bar_background_color}
                    stepPositions={[100]}
                >
                    <Step transition="scale">
                        {({ position }: any) => {
                            return (
                                <div
                                    className={styles.progressBarStepContainer}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        position: "absolute",
                                        top: "-20px",
                                        left: `${position}%`,
                                        transform: "translateX(-50%)",
                                    }}
                                >
                                    <RenderCapacityIcon
                                        bar_background_color={bar_background_color}
                                        bar_foreground_color={bar_foreground_color}
                                        accomplished={accomplished}
                                    />

                                    {/* Capacity label */}
                                    <span
                                        className={styles.discountLabelWrapper}
                                        style={{
                                            marginTop: "4px",
                                            textAlign: "center",
                                            fontSize: 12,
                                            fontWeight: 500,
                                            lineHeight: "15px",
                                            width: 90,
                                            color: textColor,
                                        }}
                                    >
                                        <div
                                            className={styles.discountLabelContent}
                                            id="bundle_progress_bar_capacity"
                                            style={{ lineHeight: "normal" }}
                                        >
                                            {filledCapacity} / {totalCapacity} ml
                                        </div>
                                    </span>
                                </div>
                            );
                        }}
                    </Step>
                </ProgressBar>
            </span>
        </>
    );
};

const IndividualCapacityProgressBar = ({
    selectedProducts,
    bar_foreground_color,
    bar_background_color,
    textColor,
}: {
    selectedProducts: ProductObj[];
    bar_foreground_color: string;
    bar_background_color: string;
    textColor: string;
}) => {
    useEffect(() => {
        const ele: any = document.getElementsByClassName("RSPBprogression");
        if (ele.length > 0) {
            ele[0].style.display = "block";
        }
    }, []);

    // Collect all selected variants that have a numeric capacityValue
    const capacityMap = new Map<string, { capacityValue: number; title: string; id: string }>();
    for (const product of selectedProducts) {
        for (const variant of product.selectedVariants ?? []) {
            const val = parseFloat((variant as any)?.capacityValue);
            if (!isNaN(val) && val > 0) {
                const id = variant.id;
                if (capacityMap.has(id)) {
                    capacityMap.get(id)!.capacityValue += val;
                } else {
                    capacityMap.set(id, {
                        id,
                        capacityValue: val,
                        title: variant.title ?? "",
                    });
                }
            }
        }
    }

    const capacityVariants = Array.from(capacityMap.values());

    if (capacityVariants.length === 0) return null;

    // Sort ascending by capacityValue
    const sorted = [...capacityVariants].sort((a, b) => a.capacityValue - b.capacityValue);
    const numberOfSteps = sorted.length;

    // How many non-capacity variants are selected (these are "used" slots)
    const selectedCapacity = selectedProducts.reduce(
        (sum, product) =>
            sum +
            (product.selectedVariants?.filter((variant: any) => isNaN(parseFloat(variant?.capacityValue))).length ?? 0),
        0,
    );
    const maxCapacity = sorted[numberOfSteps - 1].capacityValue;

    const stepPositions = (() => {
        if (numberOfSteps === 1) return [100];

        const startPosition = 10;
        const availableSpace = 90;

        return sorted.map((item) => {
            return startPosition + (item?.capacityValue / maxCapacity) * availableSpace;
        });
    })();

    const percent = (() => {
        if (selectedCapacity <= 0) return 2;
        const startPosition = 10;
        const availableSpace = 90;

        const getPosition = (capacity: number) => startPosition + (capacity / maxCapacity) * availableSpace;

        // Before first milestone (0 -> first capacity)
        if (selectedCapacity < sorted[0].capacityValue) {
            return (selectedCapacity / sorted[0].capacityValue) * getPosition(sorted[0].capacityValue);
        }

        // Between milestones
        for (let i = 0; i < sorted.length - 1; i++) {
            const current = sorted[i].capacityValue;
            const next = sorted[i + 1].capacityValue;

            if (selectedCapacity >= current && selectedCapacity < next) {
                const currentPos = getPosition(current);
                const nextPos = getPosition(next);

                const ratio = (selectedCapacity - current) / (next - current);

                return currentPos + ratio * (nextPos - currentPos);
            }
        }

        return 100;
    })();

    return (
        <>
            <span
                className={styles.progressBarMainWrapper}
                style={{ position: "relative", transform: "translateX(0%)", minHeight: "55px", width: "100%" }}
            >
                <ProgressBar
                    className={styles.progressBarComponent}
                    percent={Math.floor(percent) || 2}
                    height={6}
                    filledBackground={bar_foreground_color}
                    unfilledBackground={bar_background_color}
                    stepPositions={stepPositions}
                >
                    {sorted.map((item, i) => {
                        const isAccomplished = i < selectedCapacity;
                        const previousCapacity = i === 0 ? 0 : sorted[i - 1].capacityValue;
                        const isCurrentStep =
                            selectedCapacity >= previousCapacity && selectedCapacity < item.capacityValue;

                        return (
                            <Step key={i} transition="scale">
                                {({ position }: any) => (
                                    <div
                                        className={styles.progressBarStepContainer}
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            position: "absolute",
                                            top: "-20px",
                                            left: `${position}%`,
                                            transform: "translateX(-50%)",
                                        }}
                                    >
                                        <RenderCapacityIcon
                                            bar_background_color={bar_background_color}
                                            bar_foreground_color={bar_foreground_color}
                                            accomplished={isAccomplished}
                                        />
                                        <span
                                            className={styles.discountLabelWrapper}
                                            style={{
                                                marginTop: "4px",
                                                textAlign: "center",
                                                fontSize: 11,
                                                fontWeight: 500,
                                                lineHeight: "14px",
                                                width: 70,
                                                color: textColor,
                                            }}
                                        >
                                            <div
                                                className={styles.discountLabelContent}
                                                style={{ lineHeight: "normal" }}
                                            >
                                                {isCurrentStep
                                                    ? `${selectedCapacity} / ${item.capacityValue} ml`
                                                    : `${item.capacityValue} ml`}
                                            </div>
                                        </span>
                                    </div>
                                )}
                            </Step>
                        );
                    })}
                </ProgressBar>
            </span>
        </>
    );
};

const CapacityProgressBar = ({
    selectedProducts,
    bundleConfig,
    mergeTotalCapacity = true,
}: {
    selectedProducts: ProductObj[];
    bundleConfig: any;
    mergeTotalCapacity?: boolean;
}) => {
    if (mergeTotalCapacity) {
        return (
            <MergedCapacityProgressBar
                selectedProducts={selectedProducts}
                bar_foreground_color={bundleConfig?.bundles_design?.progress_bar_color || "#00FFD1"}
                bar_background_color={bundleConfig?.bundles_design?.progress_bar_bg_color || "#484545"}
                textColor={bundleConfig?.bundles_design?.total_footer_text_color || "#FFFFFF"}
            />
        );
    }
    return (
        <IndividualCapacityProgressBar
            selectedProducts={selectedProducts}
            bar_foreground_color={bundleConfig?.bundles_design?.progress_bar_color || "#00FFD1"}
            bar_background_color={bundleConfig?.bundles_design?.progress_bar_bg_color || "#484545"}
            textColor={bundleConfig?.bundles_design?.total_footer_text_color || "#FFFFFF"}
        />
    );
};

export default CapacityProgressBar;
